import React from 'react';
import {
  Select,
} from 'antd';
import FormModal from '../../../../common/FormModal';

const { Option } = Select;

const SubCategoryFormModal = ({ ...props }) => (
  <FormModal
    {...props}
    formItems={[
      {
        key: 'name',
        label: 'Sub Category',
        rules: [{ required: true, message: 'Please input Sub Category!' }, { max: 25, message: 'Name must be maximum 25 characters.' }],
      },
      {
        key: 'status',
        label: 'Status',
        rules: [{ required: true, message: 'Please category status!' }],
        Component: (
          <Select placeholder='Status' size='large'>
            <Option value>Active</Option>
            <Option value={false}>Blocked</Option>
          </Select>
        ),
      },
    ]}
  />
);
export default SubCategoryFormModal;
